import React, { ReactNode } from 'react';

import { EntityListFragment } from 'core/graphql';
import {
  DataGridPageAction,
  DataGridPageContextProvider,
  DataGridPageContextProviderProps,
  DataGridPageState,
  defaultDataGridPageReducer,
  useDataGridPageContext,
} from 'shared/DataGridPageContext';

type EntitiesPageState = DataGridPageState<EntityListFragment>;
type EntitiesPageAction = DataGridPageAction<EntityListFragment>;

const entitiesPageReducer = defaultDataGridPageReducer<
  EntityListFragment,
  EntitiesPageState,
  EntitiesPageAction
>;

export interface EntitiesContextProviderProps
  extends Pick<
    DataGridPageContextProviderProps<EntityListFragment>,
    'initialStateOverrides'
  > {
  children: ReactNode;
}

export const EntitiesContextProvider = ({
  children,
  initialStateOverrides,
}: EntitiesContextProviderProps) => {
  return (
    <DataGridPageContextProvider
      reducer={entitiesPageReducer}
      initialStateOverrides={initialStateOverrides}
    >
      {children}
    </DataGridPageContextProvider>
  );
};

export const useEntitiesContext = () => {
  return useDataGridPageContext<EntityListFragment>();
};
